import { z } from "zod";

export const ZQueue = z.object({
  type: z.literal("queue"),
  queue: z.object({
    /** Ticket._id - will not be exposed to frontend. */
    // _id: z.string().optional()
    /** Position in queue (zero based). */
    index: z.number().int().optional(),
    /** Length of the queue. */
    queueLength: z.number().int().optional(),
    /** Already waited for. */
    waited: z.number().optional(),
    /** Based on Average Watch Time,
     * we calculate an average interval of expected connection closings and based on the amount of concurrent sessions,
     * we can calculate the estimated time until another slot will be freed up. */
    estimatedWaitTime: z.number().optional(),
    /** The average time all current sessions.
     * (How long did it actually take those that waited for them that received a connection to the currently running instances.)
     */
    averageWaitTime: z.number().optional(),
    /** Type of all time-values in the que. */
    valueType: z.enum(["milliseconds", "seconds", "minutes", "hours", "days"]),
  }),
});
export type Queue = z.infer<typeof ZQueue>;
